/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of PluginUtils
 */

export default abstract class PluginUtils {

    /**
     * page init上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_PAGE_INIT: string = 'OMGH5PageInit-reporting-strategy-plugin';

    /**
     * page init上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_OMGLOG: string = 'OMGH5Log-reporting-strategy-plugin';

    /**
     * page view上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_PAGE_VIEW: string = 'OMGH5PageView-reporting-strategy-plugin';

    /**
     * page leave上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_PAGE_LEAVE: string = 'OMGH5PageLeave-reporting-strategy-plugin';

    /**
     * received上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_RECEIVED: string = 'OMGH5Received-reporting-strategy-plugin';

    /**
     * click上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_CLICK: string = 'OMGH5Click-reporting-strategy-plugin';

    /**
     * js error上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_JS_ERROR: string = 'OMGH5JsError-reporting-strategy-plugin';

    /**
     * 用户自定义上报错误事件插件名
     * @type {string}
     */
    public static PLUGIN_NAME_ERROR: string = 'OMGH5Error-reporting-strategy-plugin';

    /**
     * 用户自定义埋点事件插件名
     * @type {string}
     */
    public static PLUGIN_NAME_CUSTOM: string = 'OMGH5Custom-reporting-strategy-plugin';

    /**
     * 性能上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_PERFORMANCE: string = 'OMGH5Performance-reporting-strategy-plugin';

    /**
     * 安全上报策略插件名称。
     * @type {string}
     */
    public static PLUGIN_NAME_SAFETYPING: string = 'OMGH5SafeTyping-reporting-strategy-plugin';

    /**
     * page init event id
     * @type {string}
     */
    public static EVENT_ID_PAGE_INIT: string = 'OMGH5PageInit';
    /**
     * page init event id
     * @type {string}
     */
    public static EVENT_ID_OMG_LOG: string = 'OMGH5Log';

    /**
     * page view event id
     * @type {string}
     */
    public static EVENT_ID_PAGE_VIEW: string = 'OMGH5PageView';

    /**
     * page leave event id
     * @type {string}
     */
    public static EVENT_ID_PAGE_LEAVE: string = 'OMGH5PageLeave';

    /**
     * received event id
     * @type {string}
     */
    public static EVENT_ID_RECEIVED: string = 'OMGH5Received';

    /**
     * click event id
     * @type {string}
     */
    public static EVENT_ID_CLICK: string = 'OMGH5Click';

    /**
     * js error event id
     * @type {string}
     */
    public static EVENT_ID_JS_ERROR: string = 'OMGH5JsError';

    /**
     * 用户自定义上报错误事件id
     * @type {string}
     */
    public static EVENT_ID_ERROR: string = 'OMGH5Error';

    /**
     * 性能数据上报 事件id
     * @type {string}
     */
    public static EVENT_ID_PERFORMANCE: string = 'OMGH5Performance';
    /**
     * 安全专项上报 事件id
     * @type {string}
     */
    public static EVENT_ID_SAFETYPING: string = 'OMGSafeTyping';
}
